import { Button } from '@/src/common/components/Button'
import { Dialog, YStack } from 'tamagui'
import { SimpleUpDownRating, SimpleUpDownRatingValue } from '../SimpleUpDownRating'
import { useState } from 'react'
import { SurveysE2E } from '../../e2e'

export type DetailedSurveyResponse = {
  appExperience: SimpleUpDownRatingValue
  cardValue: SimpleUpDownRatingValue
  cardRedemptions: SimpleUpDownRatingValue
  support: SimpleUpDownRatingValue
  partnersAndBenefits: SimpleUpDownRatingValue
}

export const DetailedSurvey = ({
  onSubmit,
}: {
  onSubmit: (response: DetailedSurveyResponse) => void
}) => {
  const [appExperience, setAppExperience] = useState<SimpleUpDownRatingValue>(0)
  const [cardValue, setCardValue] = useState<SimpleUpDownRatingValue>(0)
  const [cardRedemptions, setCardRedemptions] = useState<SimpleUpDownRatingValue>(0)
  const [support, setSupport] = useState<SimpleUpDownRatingValue>(0)
  const [partnersAndBenefits, setPartnersAndBenefits] = useState<SimpleUpDownRatingValue>(0)

  const handleSubmit = () => {
    onSubmit({
      appExperience,
      cardValue,
      cardRedemptions,
      support,
      partnersAndBenefits,
    })
  }

  return (
    <>
      <Dialog.Title key="title" text="center" fontSize="$6" lineHeight="$10">
        Thank you for your feedback!
      </Dialog.Title>
      <Dialog.Description fontSize="$4" lineHeight="$2">
        We're looking for ways to improve the Mesa Homeowners Card. Please take a moment to share
        your opinion on the following:
      </Dialog.Description>
      <YStack gap="$4" mt="$6">
        <SimpleUpDownRating
          title="App experience"
          rating={appExperience}
          onRatingChange={setAppExperience}
          testIDTitle="AppExperience"
        />
        <SimpleUpDownRating
          title="Card value"
          rating={cardValue}
          onRatingChange={setCardValue}
          testIDTitle="CardValue"
        />
        <SimpleUpDownRating
          title="Card redemptions"
          rating={cardRedemptions}
          onRatingChange={setCardRedemptions}
          testIDTitle="CardRedemptions"
        />
        <SimpleUpDownRating
          title="Support"
          rating={support}
          onRatingChange={setSupport}
          testIDTitle="Support"
        />
        <SimpleUpDownRating
          title="Partners and benefits"
          rating={partnersAndBenefits}
          onRatingChange={setPartnersAndBenefits}
          testIDTitle="PartnersAndBenefits"
        />
        <Button
          title="Submit"
          onPress={handleSubmit}
          mt="$2"
          testID={SurveysE2E.Ids.Press.SubmitDetailedRating}
        />
      </YStack>
    </>
  )
}
